<div class="allergy-creator-container">
    <div class="header">
        <div class="header-actions">
            <h3>{{heading}}</h3>
            <button mat-icon-button (click)="openAddAllergyDialog()" matTooltip="Add new allergy" *ngIf="!hideActions"
                color="primary">
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <mat-checkbox *ngIf="!hideActions && !hideCheckbox" [(ngModel)]="noAllergies" name="noAllergies"
            class="checkbox" (change)="toggleNoAllergies()">No
            Allergies / Alerts</mat-checkbox>
    </div>
    <ng-container *ngIf="!noAllergies || hideActions">
        <mat-form-field class="full-width" appearance="outline" (click)="openAddAllergyDialog()">
            <mat-label>Allergies/Alerts</mat-label>
            <mat-chip-grid #chipGrid>
                <mat-chip-row *ngFor="let allergy of allergies" (click)="$event.stopPropagation()"
                    [appTouchEdit]="!hideActions" (dblclick)="hideActions ? {} : editAllergy(allergy)" [matTooltip]="getTooltipText(allergy)">
                    {{allergy.allergy}}
                    <mat-icon *ngIf="reported(allergy)" class="patient-reported-mark" aria-label="Patient reported">person</mat-icon>
                    <button matChipRemove (click)="removeAllergy(allergy)" *ngIf="!hideActions">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </mat-chip-grid>
            <input [matChipInputFor]="chipGrid" disabled />
            <mat-hint *ngIf="!hideActions">Double click or tap and hold an allergy/alert to edit the information</mat-hint>
        </mat-form-field>

    </ng-container>

    <ng-template #addAllergyDialog>
        <h1 mat-dialog-title>Allergy/Alert Details</h1>
        <div mat-dialog-content>
            <div class="p-t-20">

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Allergy/Alert</mat-label>
                    <input matInput [(ngModel)]="editingAllergy.allergy" placeholder="Allergy/Alert" type="text"
                        required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Reaction/Reason</mat-label>
                    <input matInput [(ngModel)]="editingAllergy.reaction" placeholder="Reaction/Reason" type="text">
                </mat-form-field>
            </div>

        </div>
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" (click)="saveAllergy()"
                [disabled]="!editingAllergy.allergy">Save</button>
        </div>

    </ng-template>
</div>